import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import checkNotIcon from '../../../../../../../assetss/img/checkNotIcon.svg'
import './index.scss'

const AcceptRequestMessage = ({ newContent }) => (
  +newContent === 2 ? (
    <Grid className='wrapperAcceptRequestMessage'>
      <Grid className='acceptRequestMessage'>
        <img className='checkIcon' src={checkNotIcon} />
        <Grid className='textBox'>
          <Typography className='topText'>You have accepted the meeting request. Now you can negotiate the date and time in the chat.</Typography>
          <Typography className='bottomText'><span>Important</span> Only the initiator can suggest the date and time. Once set, it's displayed in the right panel.</Typography>
          <Typography className='bottomTextMobile'><span>Important</span> Only the initiator can suggest the date and time. Once suggested you can view it by clicking on “Meeting details” button.</Typography>
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <Grid className='newAcceptRequestMessageMobile'>
      <Grid className='newAcceptRequestMessageMobileBox'>
        <img className='newCheckIcon' src={checkNotIcon} />
        <Typography className='acceptText'>You have accepted meeting request</Typography>
      </Grid>
    </Grid>
  )
)

export default AcceptRequestMessage
